import React from 'react'

const About = () => {
  return <h1>Radius</h1>
}

export default About
